<template>
    <div id="preferred-departments">
        <div class="preferred-departments-container">
            <span
                class="preferred-departments-element"
                v-for="department of getSelecteddepartments()"
                v-tippy="{
                    followCursor: true,
                    placement: 'bottom-end',
                }"
                :content="getDepartmentName(department)"
                :key="department._id"
            >
                <div class="circle" :style="{ backgroundColor: isDarkMode ? 'white' : 'black' }"></div>
                <div @click="visibleModal = true">
                    {{ getDepartmentName(department).slice(0, 15) + (getDepartmentName(department).length >= 15 ? "..." : "") }}
                </div>
            </span>
            <button class="add-dashed-btn" @click="visibleModal = true" v-if="!readOnly">
                <span class="material-icons">add</span>
            </button>
        </div>
        <FormModal
            :title="$t('message.assignPreferredDepartment')"
            :subtitle="$t('message.departmentAssignedToTheVisitor')"
            v-if="visibleModal"
            v-model="selectedDepartmentId"
            @cancel="visibleModal = false"
            class="preferred-departments-form"
        >
            <template #body>
                <div class="pf-main">
                    <div class="pr-search">
                        <input
                            :placeholder="$t('message.searchForDepartment')"
                            v-model="searchText"
                            @input="searchChange"
                        />
                        <span class="material-icons mx-2 pr-icon"> search </span>
                    </div>
                    <hr />
                    <div class="pr-items pr-item-wrapper">
                        <div class="pr-item" @click="toggleDepartment('')">
                            <a-checkbox class="segment-checkbox" :checked="selectedDepartmentId===''" />

                            <div class="user-data-wrapper">
                                <div class="user-data">
                                    <div class="metas">
                                        <div class="pr-item-name">{{ $t('message.noPreferredDepartment') }}</div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="pr-item" v-for="department of filteredDepartments" @click="toggleDepartment(department._id)">
                            <a-checkbox class="segment-checkbox" :checked="selectedDepartmentId===department._id" />

                            <div class="user-data-wrapper">
                                <div class="user-data">
                                    <div class="metas">
                                        <div class="pr-item-name">{{ getDepartmentName(department) }}</div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </template>
            <template #footer>
                <div class="actions">
                    <a-button @click="handleCancel"> {{ $t("message.cancel") }}</a-button>
                    <a-button class="pr-confirm-btn" @click='handleConfirm' type="primary" :disabled="!isChanged()">
                        {{ $t("message.save") }}
                    </a-button>
                </div>
            </template>
        </FormModal>
    </div>
</template>

<script>
import _ from "lodash";
import { mapActions, mapGetters, mapState } from "vuex";
import log2 from "../utils/log2";
import FormModal from "./FormModal.vue";
import Templates from "../views/Pages/Chatbot/pages/templates/Templates.vue";
import Avatar from "vue-avatar";
import { sendSocketMessage } from "../utils/socketStream";

const log = log2("PreferredDepartments");
export default {
    name: "PreferredDepartment",
    props: {
        readOnly: {
            type: Boolean,
            default: false,
        },
        visitorId: {
            type: String,
            required: true,
        },
        footerVisibility: {
            type: Boolean,
            default: true,
        },
        value: {
            type: String,
            required: false,
        },
    },
    components: {
        Templates,
        FormModal,
        Avatar,
    },
    emits: ["cancel"],
    data({ value }) {
        return {
            searchText: '',
            selectedDepartmentId: value || '',
            search: "",
            visibleModal: false,
        };
    },
    computed: {
        ...mapGetters({
            isDarkMode: "user/isDarkMode",
        }),
        ...mapState({
            users: (state) => state.user.users.data,
            filterUsers: (state) => _.cloneDeep(state.user.users.data),
            user: (state) => state.auth.user,
            departments: (state) => state.subject.subjects.data,
            filteredDepartments: (state) => _.cloneDeep(state.subject.subjects.data),
            site: (state) => state.site.site,
        }),
        filteredDepartments() {
            return this.departments.filter((x) => new RegExp(this.search, "gi").test(this.getDepartmentName(x)));
        },
    },
    methods: {
        ...mapActions({
            updatePreferredAgents: "visitor/updatePreferredAgents",
            updatePreferredDepartment: "visitor/updatePreferredDepartment",
        }),
        getDepartmentName(sub){
            const target =this.departments.find((x) => x._id === sub._id)
            return target.languageContent[this.$i18n.locale].name.toLowerCase() || target.languageContent[Object.keys(target.languageContent)[0]].name.toLowerCase()
        },
        async save() {
            return await this.updatePreferredDepartment({
                visitorId: this.visitorId,
                departmentId: this.selectedDepartmentId,
            }).then((data) => {
                sendSocketMessage("user sync-visitor", {
                    siteId: this.site._id,
                    visitorId: this.visitorId,
                });
                return data;
            });
        },
        toggleDepartment(departmentId) {
            this.selectedDepartmentId = departmentId;
        },
        searchChange() {
            this.search = this.searchText;
        },
        async handleConfirm() {
            await this.save();
            this.$emit("input", this.selectedDepartmentId);
            this.visibleModal = false;
            this.$emit("cancel");
        },
        handleCancel() {
            this.visibleModal = false;
            this.$emit("cancel");
        },
        isChanged() {
            return !_.isEqual(this.selectedDepartmentId, this.value);
        },
        getSelecteddepartments() {
            return (this.departments || '').filter((u) => this.selectedDepartmentId.includes(u._id));
        },
    },
    watch: {
        value: {
            handler: function (val) {
                if (_.isEqual(val, this.selectedDepartmentId)) return;
                this.selectedDepartmentId = _.cloneDeep(val || '');
            },
            deep: true,
        },
    },
};
</script>

<style lang="scss">
.preferred-departments-container {
    display: flex;
    flex-wrap: wrap;
    .add-dashed-btn {
        width: 24px;
        height: 24px;
        border-radius: 4px;
        border: 1px dashed #6f63f2;
        background-color: #fff;
        color: #6f63f2;
        display: flex;
        align-items: center;
        justify-content: center;
        cursor: pointer;
        transition: all 0.2s;

        &:hover {
            background-color: #7561f333;
            transform: scale(1.05);
        }

        .material-icons {
            font-size: 16px;
        }
    }
    .preferred-departments-element {
        border-radius: 10px;
        border-style: solid;
        color: black;
        display: flex;
        justify-content: center;
        align-items: center;
        margin: 1px;
        padding: 0px 4px;

        .circle {
            width: 10px;
            height: 10px;
            margin-right: 5px;
            border-radius: 100%;
        }
    }
}

.dark-mode .preferred-departments-element {
    color: white;
}
</style>

<style lang="scss" scoped>
.classic-button {
    border: none;
    background-color: #ffa80040 !important;
    color: #ffa800 !important;
    font-family: Poppins;
    font-weight: 600 !important;
    font-size: 14px;
    cursor: pointer;
    padding: 3px 10px;
    border-radius: 6px;
    display: flex;
    justify-content: center;
    align-items: center;
}

.pf-main {
    display: flex;
    flex-direction: column;
    background: var(--color-bg-default);
    border: 1px solid var(--color-border-default);
    padding: 5px;

    .pr-search {
        display: flex;
        justify-content: center;
        align-items: center;
        position: relative;
        width: 100%;

        input {
            border: 1px solid #c6cdd4 !important;
            width: 100%;
            padding: 10px;
            padding-right: 40px;
            border-radius: 5px;
            transition: all 0.3s;
        }

        input:focus {
            border: 1px solid black !important;
        }

        .pr-icon {
            position: absolute;
            right: 4px;
        }
    }

    .pr-items {
        min-height: 300px;
        max-height: 300px;
        overflow: auto;

        .pr-item:last-child {
            border-bottom: none;
        }

        .pr-item {
            display: flex;
            justify-content: start;
            align-items: center;
            flex-wrap: nowrap;
            padding: 5px 10px;
            border-radius: 4px;
            cursor: pointer;
            gap: 10px;
            border-bottom: 1px solid var(--color-border-default);

            &:hover {
                background: var(--color-bg-neutral-hover);
            }

            .user-data-wrapper {
                width: 100%;
                display: flex;
                justify-content: space-between;

                padding: 0 5px;

                .user-data {
                    display: flex;
                    gap: 5px;
                    align-items: center;

                    .avatar {
                        color: var(--color-text-onprimary-default);
                    }

                    .metas {
                        display: flex;
                        flex-direction: column;
                    }
                }
            }

            .pr-item-status {
                display: flex;
                justify-content: center;
                align-items: center;

                .pr-item-status-circle {
                    width: 10px;
                    height: 10px;
                    border-radius: 100%;
                    margin-right: 2px;
                }

                &[data-online="true"] {
                    &[data-status="online"] {
                        color: #1bc5bd !important;

                        .pr-item-status-circle {
                            background: #1bc5bd !important;
                        }
                    }

                    &[data-status="away"] {
                        color: #3699ff !important;

                        .pr-item-status-circle {
                            background: #3699ff !important;
                        }
                    }

                    &[data-status="busy"] {
                        color: #ffa829 !important;

                        .pr-item-status-circle {
                            background: #ffa829 !important;
                        }
                    }

                    &[data-status="offline"] {
                        color: #f64e60 !important;

                        .pr-item-status-circle {
                            background: #f64e60 !important;
                        }
                    }
                }

                &:not([data-online]) {
                    &[data-status="online"] {
                        color: var(--color-text-disabled);

                        .pr-item-status-circle {
                            background: var(--color-text-disabled) !important;
                        }
                    }

                    &[data-status="away"] {
                        color: var(--color-text-disabled);

                        .pr-item-status-circle {
                            background: var(--color-text-disabled) !important;
                        }
                    }

                    &[data-status="busy"] {
                        color: var(--color-text-disabled);

                        .pr-item-status-circle {
                            background: var(--color-text-disabled) !important;
                        }
                    }

                    &[data-status="offline"] {
                        color: var(--color-text-disabled);

                        .pr-item-status-circle {
                            background: var(--color-text-disabled) !important;
                        }
                    }
                }
            }
        }
    }
}
</style>
